import { Navigate } from "react-router-dom";
import { useAuth } from "../state/appContext";

const ProtectedRoute = ({ children }) => {
  const { loggedIn, user, loader } = useAuth();

  if (loader) return <p>Loading...</p>;

  if (!loggedIn || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
